import { FC, Fragment } from "react";
import { Divider, Stack } from "@mui/material";
import { useFlag } from "@unleash/proxy-client-react";
import { BillingExplorerSettingsPanelHeader } from "./components/BillingExplorerSettingsPanelHeader";

import { BillingExplorerChartSettingsSection } from "@/components/pages/resource-explorer/components/settings-panel/components/chart-settings-section/BillingExplorerChartSettingsSection";
import { ViewTrendSettings } from "@/components/pages/resource-explorer/components/settings-panel/components/trend-settings-section/ViewTrendSettings";
import { ViewCostTypeSettings } from "@/components/pages/resource-explorer/components/settings-panel/components/cost-type-settings-section/ViewCostTypeSettings";
import { ViewTagsSettings } from "@/components/pages/resource-explorer/components/settings-panel/components/tags-settings-section/ViewTagsSettings";

interface BillingExplorerSettingsPanelProps {
  onClose(): void;
}

export const BillingExplorerSettingsPanel: FC<
  BillingExplorerSettingsPanelProps
> = ({ onClose }) => {
  const enableCustomTagsEnablementForAWS = useFlag(
    "EnableCustomTagsEnablementForAWS",
  );

  return (
    <Fragment>
      <BillingExplorerSettingsPanelHeader onClose={onClose} />

      <Stack spacing={1.5} py={1.5} divider={<Divider flexItem />}>
        <ViewTrendSettings />

        <ViewCostTypeSettings />

        <BillingExplorerChartSettingsSection />

        {enableCustomTagsEnablementForAWS && <ViewTagsSettings />}
      </Stack>
    </Fragment>
  );
};
